// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3f_Qa","question":"Question_question__1kX3C","description":"Question_description__2ExgF"};